import * as React from "react";
import "./MethodSubtitle.scss";
import PropTypes from "prop-types";

const MethodSubtitle = (props) => {
  const subtitle = props.subtitle;
  const subtitleClass = "method-desktop-subtitle";
  const borderClass = props.hasBorder ? ` method-desktop-bordered` : "";
  return (
    <div className={subtitleClass + borderClass}>
      <div>{subtitle && subtitle}</div>
    </div>
  );
};

MethodSubtitle.propTypes = {
  subtitle: PropTypes.string.isRequired,
  hasBorder: PropTypes.boolean,
};

export default MethodSubtitle;
